var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c("router-link", { attrs: { to: { name: "Home" } } }, [
                _vm._v("Accueil"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "breadcrumb-item active",
              attrs: { "aria-current": "page" },
            },
            [_vm._v("Dépannage")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Filtrer",
                    "label-cols-sm": "3",
                    "label-align-sm": "left",
                    "label-size": "sm",
                    "label-for": "filterInput",
                  },
                },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filterInput",
                          type: "search",
                          placeholder: "Taper pour rechercher un dépannage",
                        },
                        model: {
                          value: _vm.filter,
                          callback: function ($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: !_vm.filter },
                              on: {
                                click: function ($event) {
                                  _vm.filter = ""
                                },
                              },
                            },
                            [_vm._v("Effacer")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        attrs: {
          fields: _vm.fields,
          items: _vm.troubleshoots,
          filter: _vm.filter,
          "filter-included-fields": _vm.filterOn,
          small: "",
          responsive: "sm",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(tbs_id)",
            fn: function (row) {
              return [_c("b-col", [_vm._v(_vm._s(row.item.tbs_id))])]
            },
          },
          {
            key: "cell(esta_internal_name)",
            fn: function (row) {
              return [
                _c("b-col", [_vm._v(_vm._s(row.item.esta_internal_name))]),
              ]
            },
          },
          {
            key: "cell(tbs_type)",
            fn: function (row) {
              return [
                row.item.tbs_type === "modu"
                  ? _c("b-badge", { attrs: { variant: "info" } }, [
                      _vm._v("Module"),
                    ])
                  : row.item.tbs_type === "par"
                  ? _c("b-badge", { attrs: { variant: "warning" } }, [
                      _vm._v("Résident"),
                    ])
                  : row.item.tbs_type === "staf"
                  ? _c("b-badge", { attrs: { variant: "success" } }, [
                      _vm._v("Personnel"),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(help_label)",
            fn: function (row) {
              return [_c("b-col", [_vm._v(_vm._s(row.item.help_label))])]
            },
          },
          {
            key: "cell(tbs_status)",
            fn: function (row) {
              return [
                row.item.tbs_status === "CREATED"
                  ? _c("b-badge", { attrs: { variant: "info" } }, [
                      _vm._v("Créé"),
                    ])
                  : row.item.tbs_status === "SEND"
                  ? _c("b-badge", { attrs: { variant: "warning" } }, [
                      _vm._v("Envoyé"),
                    ])
                  : row.item.tbs_status === "DONE"
                  ? _c("b-badge", { attrs: { variant: "success" } }, [
                      _vm._v("Traité"),
                    ])
                  : row.item.tbs_status === "FAIL"
                  ? _c("b-badge", { attrs: { variant: "danger" } }, [
                      _vm._v("Erreur"),
                    ])
                  : row.item.tbs_status === "CANCEL"
                  ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                      _vm._v("Annulé"),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(update)",
            fn: function (row) {
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        row.item.tbs_status === "CREATED"
                          ? _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelTroubleshoot(row.item)
                                  },
                                },
                              },
                              [_vm._v("Annuler")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }